import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import { StylesProvider } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import PropTypes from 'prop-types';
import { AppContextProvider } from '@bit/glinzcovis.shamekit.app-context';
import ApolloSetup from './ApolloSetup';
import './App.css';
import { Auth0Provider } from './auth0-wrapper';
import MustLogin from './components/auth/MustLogin';
import TenantProvider from './TenantProvider';
import { GlobalStyle } from './global/DapTheme';
import TenantThemeProvider from './TenantThemeProvider';
import Routes from './Routes';
import HttpSetup from './HttpSetup';

const App = ({ config }) => {
  const { auth0Settings } = config;

  return (
    <AppContextProvider config={config}>
      <Auth0Provider
        domain={auth0Settings.domain}
        client_id={auth0Settings.clientID}
        redirect_uri={window.location.origin}
        audience={auth0Settings.audience}
      >
        <MustLogin>
          <ApolloSetup>
            <HttpSetup>
              <TenantProvider>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <Router>
                    <StylesProvider injectFirst>
                      <TenantThemeProvider>
                        <CssBaseline />
                        <GlobalStyle />

                        <Routes />
                      </TenantThemeProvider>
                    </StylesProvider>
                  </Router>
                </MuiPickersUtilsProvider>
              </TenantProvider>
            </HttpSetup>
          </ApolloSetup>
        </MustLogin>
      </Auth0Provider>
    </AppContextProvider>
  );
};

App.propTypes = {
  config: PropTypes.object.isRequired,
};

export default App;
